import { motion } from "framer-motion";
import { ShieldCheck, FileText, Camera, Clock, UserCheck } from "lucide-react";
import { PILLARS } from "@/lib/content";

const EASE = [0.22, 1, 0.36, 1];
const ICONS = { ShieldCheck, FileText, Camera, Clock, UserCheck };

export default function Operate() {
  return (
    <section
      id="operate"
      data-testid="operate-section"
      className="bg-slate-900 py-24 text-white sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-16 max-w-2xl"
        >
          <p className="font-mono-accent mb-4 text-xs uppercase tracking-[0.24em] text-amber-500">
            The Operating Standard
          </p>
          <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            How Michael Operates
          </h2>
          <p className="font-serif-accent mt-4 text-lg italic text-slate-400">
            No mystery pricing. No unannounced arrivals. No abandoned jobs.
          </p>
        </motion.div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <motion.div
                key={p.title}
                data-testid={`pillar-card-${i}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
                className={`group rounded-3xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur-sm transition-colors duration-300 hover:border-amber-500/40 hover:bg-white/[0.07] ${
                  i === 4 ? "sm:col-span-2 lg:col-span-1" : ""
                }`}
              >
                <span className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500/15 text-amber-500 transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-110">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="font-display text-lg font-semibold">{p.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
